import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import './FloatingCartSummary.css';
import { optimizedUrl } from "./Image";

export default function FloatingCartSummary() {
  const { cart, cartCount, cartTotal, toggleCart } = useCart();
  const location = useLocation();

  if (cartCount === 0 || location.pathname === '/checkout' || location.pathname === '/cart' || location.pathname.startsWith('/product/') || location.pathname.startsWith('/admin')) {
    return null;
  }

  // Get the last added item image or first item image
  const image = optimizedUrl(
    cart.items?.[cart.items.length - 1]?.productId?.images?.[0] ||
      cart.items?.[0]?.productId?.images?.[0],
    120
  ) || '/akb1.png';

  return (
    <div className="floating-cart-summary-wrapper slide-up-anim">
      <button onClick={() => toggleCart(true)} className="floating-cart-pill" style={{border: 'none', cursor: 'pointer', textAlign: 'left', width: '100%', fontFamily: 'inherit'}}>
        <div className="fc-left">
          <div className="fc-img-wrapper">
            <img src={image} alt="Cart item" />
          </div>
          <div className="fc-info">
            <span className="fc-items">{cartCount} {cartCount > 1 ? 'items' : 'item'}</span>
            <span className="fc-total">₹{cartTotal}</span>
          </div>
        </div>
        <div className="fc-right">
          <span className="fc-checkout-text">View Cart</span>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
          </svg>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{marginLeft: 4}}>
             <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </div>
      </button>
    </div>
  );
}
